import { MicrosoftOutlookIcon } from "#components/ui/MicrosoftOutlookIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const outlookManifest: IntegrationManifest = {
    key: "outlook",
    displayName: "Outlook",
    nameKey: "channels.outlook",
    descriptionKey: "outlookDescription",
    trayDescriptionKey: "composerTrayDescriptions.outlook",
    cardDescriptionKey: "connectIntegration.descriptions.outlook",
    connectedContentKeys: ["outlookEmails", "outlookCalendarEvents"],
    brandColor: "#0F6CBD",
    iconUrl: IconAssets.Outlook,
    iconUrlAlt: IconAssets.OutlookAlt,
    glyph: MicrosoftOutlookIcon,
    channelType: "UserOutlook",
    dataSources: ["outlook_message", "outlook_calendar_event"]
};
